import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Vue3Storage from 'vue3-storage'
import TealiumPlugin from './plugins/tealium'
import WebMcpPlugin from './plugins/webmcp'

let appName = sessionStorage.getItem('appName')

createApp(App)
.use(router)
.use(Vue3Storage, { namespace: "" })
.use(TealiumPlugin, {
	initialData: {
		app_name: appName,
	}
})
.use(WebMcpPlugin, {router})
.mount('#app')